var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationObserver", {
    ref: "observer",
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function({ handleSubmit, invalid, pristine }) {
          return [
            _c(
              "form",
              {
                staticClass: "form-horizontal",
                attrs: { novalidate: "", name: "changePasswordForm" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return handleSubmit(_vm.changePassword)
                  }
                }
              },
              [
                _c("div", { staticClass: "container-fluid" }, [
                  _c("fieldset", { staticClass: "m-t-15" }, [
                    _c("legend", { staticClass: "m-l-20" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("CHANGE_PASSWORD_TITLE")) +
                          "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "label",
                          { staticClass: "col-sm-3 col-md-3 control-label" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CHANGE_PASSWORD_OLD_PASSWORD_LABEL")
                              ) + "\n            "
                            ),
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$t(
                                      "CHANGE_PASSWORD_OLD_PASSWORD_TT"
                                    ),
                                    expression:
                                      "$t('CHANGE_PASSWORD_OLD_PASSWORD_TT')"
                                  }
                                ],
                                staticClass: "tooltip-icon"
                              },
                              [
                                _c("i", {
                                  staticClass: "fa m-l-3 fa-question-circle"
                                })
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("ValidationProvider", {
                          attrs: {
                            rules: "required",
                            name: "Current Password"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors, classes }) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-sm-4 col-md-3",
                                        class: classes
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.changeRequest.oldPassword,
                                              expression:
                                                "changeRequest.oldPassword"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            type: "password",
                                            name: "oldPassword",
                                            placeholder: _vm.$t(
                                              "CHANGE_PASSWORD_OLD_PASSWORD_PH"
                                            )
                                          },
                                          domProps: {
                                            value: _vm.changeRequest.oldPassword
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.changeRequest,
                                                "oldPassword",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "label",
                          { staticClass: "col-sm-3 col-md-3 control-label" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CHANGE_PASSWORD_NEW_PASSWORD_LABEL")
                              ) + "\n            "
                            ),
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$t(
                                      "CHANGE_PASSWORD_NEW_PASSWORD_TT"
                                    ),
                                    expression:
                                      "$t('CHANGE_PASSWORD_NEW_PASSWORD_TT')"
                                  }
                                ],
                                staticClass: "tooltip-icon"
                              },
                              [
                                _c("i", {
                                  staticClass: "fa m-l-3 fa-question-circle"
                                })
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("ValidationProvider", {
                          attrs: {
                            name: "New Password",
                            rules: "required|passwordLength|password"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors, classes }) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-sm-4 col-md-3",
                                        class: classes
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.changeRequest.password,
                                              expression:
                                                "changeRequest.password"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            type: "password",
                                            placeholder: _vm.$t(
                                              "CHANGE_PASSWORD_NEW_PASSWORD_PH"
                                            ),
                                            name: "password"
                                          },
                                          domProps: {
                                            value: _vm.changeRequest.password
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.changeRequest,
                                                "password",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "text-danger",
                                            attrs: {
                                              "data-testid": "passwordError"
                                            }
                                          },
                                          [_vm._v(_vm._s(errors[0]))]
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "label",
                          { staticClass: "col-sm-3 col-md-3 control-label" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "CHANGE_PASSWORD_CONFIRM_NEW_PASSWORD_LABEL"
                                )
                              ) + "\n            "
                            ),
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$t(
                                      "CHANGE_PASSWORD_CONFIRM_NEW_PASSWORD_TT"
                                    ),
                                    expression:
                                      "$t('CHANGE_PASSWORD_CONFIRM_NEW_PASSWORD_TT')"
                                  }
                                ],
                                staticClass: "tooltip-icon"
                              },
                              [
                                _c("i", {
                                  staticClass: "fa m-l-3 fa-question-circle"
                                })
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("ValidationProvider", {
                          attrs: {
                            name: "Confirm Password",
                            rules: "required|passwordMatch:@New Password"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors, classes }) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-sm-4 col-md-3",
                                        class: classes
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.changeRequest
                                                  .confirmPassword,
                                              expression:
                                                "changeRequest.confirmPassword"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            type: "password",
                                            placeholder: _vm.$t(
                                              "CHANGE_PASSWORD_CONFIRM_NEW_PASSWORD_PH"
                                            ),
                                            name: "confirmPassword"
                                          },
                                          domProps: {
                                            value:
                                              _vm.changeRequest.confirmPassword
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.changeRequest,
                                                "confirmPassword",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "text-danger",
                                            attrs: {
                                              "data-testid":
                                                "confirmPasswordError"
                                            }
                                          },
                                          [_vm._v(_vm._s(errors[0]))]
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-md-offset-3 col-sm-offset-3 col-md-8 col-sm-8"
                        },
                        [
                          _c(
                            "PrimaryButton",
                            {
                              attrs: {
                                type: "submit",
                                "size-class": "btn-lg",
                                "show-loader-on-form": _vm.isUpdating,
                                disabled: pristine || invalid
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("CHANGE_PASSWORD_BUTTON")) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ])
              ]
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }